import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import { MContentHeaderAlignment } from './MContentHeader.types';

const { spacers } = baseVariables;

export const ContentHeaderWrapper = styled.div<{ $alignment?: MContentHeaderAlignment }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-block-end: ${spacers?.spacers?.[4] ?? '1.5rem'};

  @media (min-width: 768px) {
    align-items: flex-end;
    ${({ $alignment }) =>
      $alignment === MContentHeaderAlignment.Centered
        ? `
          align-items: center;
          text-align: center;
        `
        : `
          flex-direction: row;
          justify-content: space-between;
        `}
  }
`;

export const TextBlockWrapper = styled.div<{ $alignment?: MContentHeaderAlignment }>`
  min-width: 0;

  @media (min-width: 768px) {
    max-width: ${({ $alignment }) => ($alignment === MContentHeaderAlignment.Centered ? '752px' : '768px')};
    ${({ $alignment }) => ($alignment !== MContentHeaderAlignment.Centered ? 'min-width: 343px;' : '')}
  }
`;

export const ButtonGroup = styled.div<{ $alignment?: MContentHeaderAlignment }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $alignment }) => ($alignment === MContentHeaderAlignment.Centered ? 'center' : 'flex-start')};
  gap: ${spacers?.spacers?.[3] ?? '1rem'};

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
  }
`;
